function isWeChat(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("micromessenger");
}

function isWeChatDevTools(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("wechatdevtools");
}

export { isWeChat, isWeChatDevTools };
